document.querySelectorAll( '.b-counter-title' ).forEach( ( block ) => {

	const numberEl = block.querySelector( '.b-counter-title__number' );
	if ( numberEl ) {

		let animated = false;
		const target = parseFloat(
			numberEl.textContent.replace( ',', '.' ).replace( /[^\d.\-]/g, '' )
		);
		if ( !isNaN( target ) ) {

			const start = 0;
			const duration = 3000;
			const isInt = Number.isInteger( target );
			/**
			 * Animates the counter from 0 to target value.
			 * @param {number} startTime - The timestamp when animation starts (from performance.now()).
			 */
			function animateCounter( startTime ) {

				/**
				 * Animation frame callback.
				 * @param {number} currentTime - The current timestamp from performance.now().
				 */
				function step( currentTime ) {

					const elapsed = currentTime - startTime;
					const progress = Math.min( elapsed / duration, 1 );
					let value = start + ( target - start ) * progress;
					value = value < 0 ? 0 : value;
					numberEl.textContent = isInt
						? Math.round( value )
						: value.toFixed( 1 ).replace( '.', ',' );
					if ( progress < 1 ) {

						requestAnimationFrame( step );

					}

				}
				requestAnimationFrame( step );

			}
			const observer = new window.IntersectionObserver( ( entries, obs ) => {

				entries.forEach( entry => {

					if ( entry.isIntersecting && !animated ) {

						animated = true;
						animateCounter( performance.now() );
						obs.disconnect();

					}

				} );

			}, { threshold: 0.2 } );
			observer.observe( block );

		}

	}

} );
